import { create } from 'zustand';

/** Per-device choices, kept in this browser only (a laptop and a phone have different mics). */
interface DevicePrefs {
  micId: string;
  speakerId: string;
  cameraId: string;
  /**
   * strong: RNNoise model; experimental: GTCRN model (newer, may handle room echo better);
   * browser: WebRTC's own suppression; off. Echo cancellation always stays on.
   */
  denoise: Denoise;
  /** Automatic gain: louder quiet voices, but also louder room tone and echo tails. */
  autoGain: boolean;
  /** A soft cue when someone else turns their mic on. */
  othersMicCue: boolean;
  set(patch: Partial<Omit<DevicePrefs, 'set'>>): void;
}

const KEY = 'novachat.devices';
export type Denoise = 'strong' | 'experimental' | 'browser' | 'off';
const defaults = { micId: 'default', speakerId: 'default', cameraId: 'default', denoise: 'strong' as Denoise, autoGain: true, othersMicCue: true };

function load(): typeof defaults {
  try {
    return { ...defaults, ...(JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<typeof defaults>) };
  } catch {
    return defaults;
  }
}

export const useDevices = create<DevicePrefs>()((set, get) => ({
  ...load(),
  set(patch) {
    set(patch);
    const { micId, speakerId, cameraId, denoise, autoGain, othersMicCue } = get();
    try {
      localStorage.setItem(KEY, JSON.stringify({ micId, speakerId, cameraId, denoise, autoGain, othersMicCue }));
    } catch {
      // private mode or storage disabled: the choice lasts for this tab only
    }
  },
}));
